/* =============================================================================
   christina-a11y-r5.js — v2.0 (2026-08-04)
   Jedno zadanie: mobile dock schowany atrybutem aria-hidden="true" nie może
   zawierać treści osiągalnej TAB-em (reguła axe `aria-hidden-focus`).

   Kontekst 1 — dlaczego nie wystarcza christina-a11y-runtime.js:
   tamten skrypt robi to samo, ale jego MutationObserver nasłuchuje wyłącznie
   `childList`. Dock nie jest wstawiany do DOM — on tylko DOSTAJE atrybut
   aria-hidden="true" od christina-layers.js (na PDP dock jest wyłączany na
   rzecz paska ATC). Zmiana atrybutu nie budzi tamtego obserwatora.

   Kontekst 2 — SHADOW DOM, właściwa przyczyna czerwonego audytu:
   w docku siedzi `<shopify-account>`, a w jego shadow root Shopify renderuje
   22 elementy fokusowalne (przycisk konta, panel konta, `<shopify-login-form>`,
   `<shop-login>` z iframe `tabindex="0"`). `querySelectorAll` NIE przechodzi
   przez granicę shadow root, ale axe/Lighthouse ją przechodzi — dlatego
   uszczelnienie samego light DOM dawało poprawny wygląd stanu końcowego
   i DALEJ czerwony aria-hidden-focus. Rekurencji po `shadowRoot` NIE USUWAĆ.

   ─ Co zmieniła v2 (trace R7) ─────────────────────────────────────────────
   v1 trzymała MutationObserver na `document.documentElement` z
   `childList: true, subtree: true`, więc KAŻDA wstawka do DOM na stronie
   (karty kolekcji, Judge.me, Klaviyo, widżety) budziła `sweep()` →
   `collect()` → `querySelectorAll('*')` po docku i po wszystkich jego
   shadow rootach. Do tego sześć bezwarunkowych przebiegów czasowych
   (300…8000 ms). Na kolekcji i stronie głównej, gdzie dock NIGDY nie
   dostaje `aria-hidden`, cała ta praca była jałowa.

   v2 — trzy zmiany, zero zmiany zachowania:
   • obserwator założony NA SAMYM DOCKU (`attributeFilter: ['aria-hidden']`
     + `childList` w jego poddrzewie), nie na całym dokumencie;
   • przebieg kończy się na jednym `if`, dopóki dock ani razu nie dostał
     `aria-hidden` (flaga `sealed`) — rekurencja po shadow DOM startuje
     dokładnie w chwili pierwszego schowania docka, a na szablonach, które
     go nie chowają, nie startuje w ogóle;
   • zamiast sześciu przebiegów czasowych zostały dwa (2,5 s i 6 s), bo
     `<shopify-account>` hydratuje się z opóźnieniem — i oba też kończą się
     na tym samym `if`, jeśli dock jest widoczny.

   Zakres celowo zawężony do `.mobile-dock`. NIE rozszerzać na wszystkie
   `[aria-hidden="true"]` — szuflady i modale motywu mają własne pułapki
   fokusa i dwukierunkowe sterowanie tabindexem skończyłoby się wyścigiem.

   Przywracanie jest symetryczne: zdejmujemy tylko te tabindexy, które sami
   ustawiliśmy (znacznik data-cc-ti).
   ============================================================================= */
(function () {
  'use strict';
  if (window.__ccA11yDock) { return; }
  window.__ccA11yDock = '2.0';

  var DOCK = '.mobile-dock';
  var FOCUSABLE = 'a[href],button,input,select,textarea,iframe,[tabindex]';
  var watched = [];
  var sealed = false;   /* czy dock kiedykolwiek został uszczelniony */

  function watchRoot(root) {
    if (!root || watched.indexOf(root) !== -1) { return; }
    watched.push(root);
    try {
      new MutationObserver(sweepSoon).observe(root, { childList: true, subtree: true });
    } catch (e) { /* ignoruj */ }
  }

  function collect(root, out) {
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.matches && el.matches(FOCUSABLE)) { out.push(el); }
      if (el.shadowRoot) {
        watchRoot(el.shadowRoot);
        collect(el.shadowRoot, out);
      }
    }
    return out;
  }

  function seal(container) {
    if (!container || !container.querySelectorAll) { return; }
    var hidden = container.getAttribute('aria-hidden') === 'true';
    /* Dock jest widoczny i nigdy nic nie chowaliśmy → nie ma czego cofać.
       Tu kończy się cała praca na kolekcjach, stronie głównej i koszyku. */
    if (!hidden && !sealed) { return; }
    if (hidden) { sealed = true; }
    var nodes = collect(container, []);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (hidden) {
        if (el.getAttribute('tabindex') !== '-1') {
          el.setAttribute('data-cc-ti', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : '');
          el.setAttribute('tabindex', '-1');
        }
      } else if (el.hasAttribute('data-cc-ti')) {
        var prev = el.getAttribute('data-cc-ti');
        if (prev === '') { el.removeAttribute('tabindex'); } else { el.setAttribute('tabindex', prev); }
        el.removeAttribute('data-cc-ti');
      }
    }
  }

  function sweep() {
    var docks = document.querySelectorAll(DOCK);
    for (var i = 0; i < docks.length; i++) { seal(docks[i]); }
  }

  var pending = null;
  function sweepSoon() {
    if (pending) { return; }
    pending = setTimeout(function () { pending = null; sweep(); }, 150);
  }

  /* obserwator ZAŁOŻONY NA DOCKU — reaguje dokładnie na przełączenie slotu
     przez christina-layers.js i na hydratację treści wewnątrz docka */
  function attach() {
    var docks = document.querySelectorAll(DOCK);
    for (var i = 0; i < docks.length; i++) {
      var d = docks[i];
      if (d.__ccA11yObs) { continue; }
      d.__ccA11yObs = 1;
      try {
        new MutationObserver(function (recs) {
          for (var j = 0; j < recs.length; j++) {
            if (recs[j].type === 'attributes') { seal(recs[j].target); }
            else { sweepSoon(); }
          }
        }).observe(d, {
          attributes: true, attributeFilter: ['aria-hidden'],
          childList: true, subtree: true
        });
      } catch (e) { /* brak MutationObserver = zostają przebiegi czasowe niżej */ }
    }
  }

  attach();
  sweep();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { attach(); sweep(); });
  }
  window.addEventListener('load', function () { attach(); sweep(); });
  setTimeout(function () { attach(); sweep(); }, 2500);
  setTimeout(sweep, 6000);
})();
